import escapeRegex from './escapeRegex';

export default (search?: string, flags = 'ig') =>
  new RegExp(escapeRegex(search) || '', flags);
